import { useCallback, useMemo, useState } from 'react';
import { ProductDeleteModalContext } from '../contexts/ProductDeleteModalContext';
import { ProductDeactivateModalContext } from '../contexts/ProductDeactivateModalContext';
import { ProductEditModalContext } from '../contexts/ProductEditModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightModalsProvider = ({
  children
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const deleteModalContextValue = useMemo(() => ({
    isDeleteModalOpen,
    setIsDeleteModalOpen
  }), [isDeleteModalOpen, setIsDeleteModalOpen]);
  const openDeactivateModal = useCallback(() => {
    setIsDeactivateModalOpen(true);
  }, [setIsDeactivateModalOpen]);
  const closeDeactivateModal = useCallback(() => {
    setIsDeactivateModalOpen(false);
  }, [setIsDeactivateModalOpen]);
  const deactivateModalContextValue = useMemo(() => ({
    isDeactivateModalOpen,
    openDeactivateModal,
    closeDeactivateModal
  }), [isDeactivateModalOpen, openDeactivateModal, closeDeactivateModal]);
  const editModalContextValue = useMemo(() => ({
    isEditModalOpen,
    setIsEditModalOpen
  }), [isEditModalOpen]);
  return /*#__PURE__*/_jsx(ProductEditModalContext.Provider, {
    value: editModalContextValue,
    children: /*#__PURE__*/_jsx(ProductDeleteModalContext.Provider, {
      value: deleteModalContextValue,
      children: /*#__PURE__*/_jsx(ProductDeactivateModalContext.Provider, {
        value: deactivateModalContextValue,
        children: children
      })
    })
  });
};